import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { TestModel } from '../models/test-model.model';

@Pipe({
  name: 'testModel'
})
@Injectable({
  providedIn: 'root'
})
export class TestModelPipe implements PipeTransform {

  transform(id: number, testModels: TestModel[]): TestModel {
    return testModels.find(model => id === model.id );
  }

}
